import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { userErrorMessage } from 'app/core/error/user-error';

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    //create an instance of MatSnackBar

    private readonly _transloco = inject(TranslocoService);

    constructor(private snackBar: MatSnackBar) {}

    /** Shows the translation of a key. */
    openTranslatedSnackBar(key: string): void {
        this.openSnackBar(this._transloco.translate(key));
    }

    /** Tells the user that something went wrong, in a short translated sentence and never with technical details (BSI O.Source_4). */
    openErrorSnackBar(error: unknown): void {
        this.openSnackBar(userErrorMessage(error, (key) => this._transloco.translate(key)));
    }

    /* It takes three parameters  
    1.the message string  
    2.the action  
    3.the duration, alignment, etc. */

    openSnackBar(message: string, action?: string, panelClass = '') {
        this.snackBar.open(message, action, {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: 3000,
            panelClass,
        });
    }
}
